import { Link } from "react-router-dom";
import { imageUrl } from "@/lib/api";
import { CalendarDays, MapPin } from "lucide-react";
import VerifiedBadge from "@/components/VerifiedBadge";
import SaveButton from "@/components/SaveButton";

const LABELS = { special: "Special", community: "Community", church: "Church" };

export default function EventCard({ event }) {
  const img = event.images?.[0];
  const d = new Date(event.start_date);
  const day = isNaN(d) ? "" : d.toLocaleDateString(undefined, { day: "2-digit" });
  const mon = isNaN(d) ? "" : d.toLocaleDateString(undefined, { month: "short" }).toUpperCase();
  const time = isNaN(d) ? "" : d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });

  return (
    <div className="relative">
      <div className="absolute top-3 right-3 z-10">
        <SaveButton type="event" id={event.id} size="icon" />
      </div>
      <Link
        to={`/events/${event.id}`}
        data-testid={`event-card-${event.id}`}
        className="abm-card overflow-hidden flex fade-in"
      >
      <div className="relative w-32 sm:w-40 shrink-0 bg-[#1E3A2F] text-[#F7F4EB] flex flex-col items-center justify-center">
        {img && (
          <img src={imageUrl(img)} alt={event.title} className="absolute inset-0 w-full h-full object-cover opacity-40" />
        )}
        <div className="relative z-10 text-center">
          <div className="text-3xl font-display leading-none">{day}</div>
          <div className="text-xs tracking-[0.2em] mt-1 text-[#DDA74A]">{mon}</div>
          <div className="text-xs mt-2">{time}</div>
        </div>
      </div>
      <div className="p-5 flex-1">
        <div className="abm-chip">{LABELS[event.category] || "Event"}</div>
        <h3 className="font-display text-lg mt-2 line-clamp-2 text-[#1A1A1A]">{event.title}</h3>
        <div className="mt-2 flex items-center gap-3 text-xs text-[#5C5C5C]">
          <span className="inline-flex items-center gap-1"><MapPin className="w-3 h-3" /> {event.location}</span>
          {event.owner_verified && <VerifiedBadge tier={event.owner_verification_tier} size="sm" />}
        </div>
        <p className="mt-2 text-sm text-[#5C5C5C] line-clamp-2">{event.description}</p>
      </div>
    </Link>
    </div>
  );
}
